import React from "react";

import LanguageTable from "../../../Common/LanguageTable";
import { BannerSection } from "../../../Common/BannerHeight";
import { templateDefaultValue } from "@constants/template";

const HEAD_PATH = ["Application", "LaindingPage", "Default", "Head"];

export function Header() {
    return (
        <div className="banner-container">
            <section className="text-section">
                <BannerSection headPath={HEAD_PATH} />
                <LanguageTable
                    path={HEAD_PATH}
                    fields={[
                        {
                            key: "Title",
                            label: "Title",
                            placeholder: "Enter the Title",
                        },
                    ]}
                    defaultTexts={
                        templateDefaultValue.Application.LaindingPage.Default
                            .Head
                    }
                    sectionTitle="Title"
                />
            </section>
        </div>
    );
}
